module.exports = __webpack_public_path__ + "1791188489487/images/NFC.df81e26.svg";